// Stockage centralise des jetons de la session ONECC.
//
// Les jetons vivent dans sessionStorage : ils doivent survivre a un rechargement
// de page pendant la recharge, mais pas a la fermeture de l'onglet.
//
// L'accessToken a une duree de vie d'une heure (cote back). Au-dela, l'API
// repond 401 : c'est apiService qui se charge de le renouveler a partir du
// refreshToken stocke ici (voir refreshAccessToken).
//
// Ne pas lire sessionStorage.getItem("accessToken") directement ailleurs :
// apres un renouvellement, seul ce module connait le jeton courant.

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

// sessionStorage peut lever (navigation privee Safari, cookies bloques) :
// une session sans jeton persiste vaut mieux qu'un ecran blanc.
const safeGetItem = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    console.error("Lecture de sessionStorage impossible:", e);
    return null;
  }
};

const safeSetItem = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    console.error("Ecriture dans sessionStorage impossible:", e);
  }
};

const safeRemoveItem = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.error("Suppression dans sessionStorage impossible:", e);
  }
};

export const getAccessToken = () => safeGetItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => safeGetItem(REFRESH_TOKEN_KEY);

// Accepte indifferemment les deux conventions de nommage du back :
// camelCase sur /onecc/setup et /onecc/sessions/*, snake_case sur /auth/refresh.
//
// Les deux jetons sont remplaces ensemble : une reponse sans refreshToken
// efface celui qui restait. Sinon le refreshToken de la session precedente
// survivrait a l'ouverture d'une nouvelle session, et le renouvellement
// suivant delivrerait des jetons pour la mauvaise session.
export const setTokens = (tokens) => {
  if (!tokens) return;

  const accessToken = tokens.accessToken || tokens.access_token;
  const refreshToken = tokens.refreshToken || tokens.refresh_token;

  if (!accessToken) return;

  safeSetItem(ACCESS_TOKEN_KEY, accessToken);

  if (refreshToken) {
    safeSetItem(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    safeRemoveItem(REFRESH_TOKEN_KEY);
  }
};

export const clearTokens = () => {
  safeRemoveItem(ACCESS_TOKEN_KEY);
  safeRemoveItem(REFRESH_TOKEN_KEY);
};
